(function () {
  'use strict';

  if (window.__themeateryA5ThresholdOfferLoaded) return;
  window.__themeateryA5ThresholdOfferLoaded = true;

  var config = {
    formId: 'W878vc',
    thresholdCents: 25000,
    discountCode: 'TRYWAGYU',
    offerGiftVariantId: 44894062084312,
    builderGiftVariantIds: [44370025840856, 44265235841240, 44152949965016],
    membershipVariantIds: [49430414885080],
    closedCooldownMs: 24 * 60 * 60 * 1000,
    pendingClaimMs: 10 * 60 * 1000,
    openRetryDelayMs: 3500,
    openMaxAttempts: 2
  };

  var keys = {
    opened: 'themeateryA5ThresholdOfferOpened',
    submitted: 'themeateryA5ThresholdOfferSubmitted',
    claimed: 'themeateryA5ThresholdOfferClaimed',
    pendingClaim: 'themeateryA5ThresholdOfferPendingClaim',
    pendingClaimAt: 'themeateryA5ThresholdOfferPendingClaimAt',
    closedAt: 'themeateryA5ThresholdOfferClosedAt',
    lastSubtotal: 'themeateryA5ThresholdOfferLastSubtotal',
    openedRendered: 'themeateryA5ThresholdOfferOpenedRendered',
    openAttempts: 'themeateryA5ThresholdOfferOpenAttempts',
    openReported: 'themeateryA5ThresholdOfferOpenReported',
    builderFunnel: 'themeateryBuilderFunnelActive'
  };

  var builderGiftVariantIds = toIdSet(config.builderGiftVariantIds);
  var membershipVariantIds = toIdSet(config.membershipVariantIds);
  var scheduledCheck = null;
  var checking = false;
  var fetchWrapped = false;
  var xhrWrapped = false;

  function toIdSet(values) {
    var set = Object.create(null);
    values.forEach(function (value) {
      set[String(value)] = true;
    });
    return set;
  }

  function storageGet(area, key) {
    try {
      return window[area].getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(area, key, value) {
    try {
      window[area].setItem(key, value);
    } catch (error) {}
  }

  function storageRemove(area, key) {
    try {
      window[area].removeItem(key);
    } catch (error) {}
  }

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function warn() {
    if (window.console && console.warn) {
      console.warn.apply(console, arguments);
    }
  }

  function extend(base, extra) {
    Object.keys(extra || {}).forEach(function (key) {
      base[key] = extra[key];
    });
    return base;
  }

  function cartItemCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function eventProps(cart, extra) {
    return extend({
      form_id: config.formId,
      discount_code: config.discountCode,
      threshold_cents: config.thresholdCents,
      qualifying_subtotal_cents: cart ? qualifyingSubtotalCents(cart) : null,
      cart_item_count: cart ? cartItemCount(cart) : null,
      path: window.location.pathname
    }, extra);
  }

  function capture(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, props || {});
      }
    } catch (error) {}
  }

  function captureOncePerSession(name, key, props) {
    var storageKey = 'themeateryA5ThresholdOfferEvent:' + key;
    if (storageGet('sessionStorage', storageKey) === '1') return;
    storageSet('sessionStorage', storageKey, '1');
    capture(name, props);
  }

  function parseRequestUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (input.url) return input.url;
    return String(input);
  }

  function pathFromUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return String(url || '');
    }
  }

  function isBuilderUrl() {
    return /\/pages\/build-your-meatery-box\/?$/i.test(window.location.pathname);
  }

  function isBuilderPage() {
    var bodyClass = document.body ? document.body.className || '' : '';
    return isBuilderUrl() ||
      bodyClass.indexOf('template-page-box-builder-v2') !== -1 ||
      Boolean(document.querySelector('.builder-v2'));
  }

  function lineVariantId(item) {
    return String(Number(item.variant_id || item.id || 0));
  }

  function lineKey(item) {
    return item.key || item.id || item.variant_id;
  }

  function hasSellingPlan(item) {
    return Boolean(item.selling_plan_allocation || item.selling_plan);
  }

  function isBuilderCartLine(item) {
    var variantId = lineVariantId(item);
    return Boolean(builderGiftVariantIds[variantId] || membershipVariantIds[variantId] || hasSellingPlan(item));
  }

  function isOfferGiftLine(item) {
    return lineVariantId(item) === String(config.offerGiftVariantId);
  }

  function offerGiftLines(cart) {
    return (cart.items || []).filter(isOfferGiftLine);
  }

  function hasOfferDiscount(item) {
    return (item.discounts || []).some(function (discount) {
      return String(discount.title || '').toUpperCase() === config.discountCode;
    });
  }

  function isOfferGiftFree(item) {
    return hasOfferDiscount(item) && Number(item.final_line_price || 0) === 0;
  }

  function isExcludedLine(item) {
    var variantId = lineVariantId(item);
    if (variantId === String(config.offerGiftVariantId)) return true;
    if (builderGiftVariantIds[variantId]) return true;
    if (membershipVariantIds[variantId]) return true;
    if (item.gift_card) return true;

    var title = String((item.product_title || '') + ' ' + (item.title || '')).toLowerCase();
    return title.indexOf('membership') !== -1 ||
      title.indexOf('gift card') !== -1 ||
      title.indexOf('shipping protection') !== -1 ||
      title.indexOf('route protection') !== -1 ||
      title.indexOf('order protection') !== -1;
  }

  function qualifyingSubtotalCents(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isExcludedLine(item)) return sum;
      return sum + Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0);
    }, 0);
  }

  function clearPendingClaim() {
    storageRemove('sessionStorage', keys.pendingClaim);
    storageRemove('sessionStorage', keys.pendingClaimAt);
  }

  function markPendingClaim() {
    storageSet('sessionStorage', keys.pendingClaim, '1');
    storageSet('sessionStorage', keys.pendingClaimAt, String(now()));
  }

  function isPendingClaimActive() {
    var pending = storageGet('sessionStorage', keys.pendingClaim) === '1';
    var pendingAt = Number(storageGet('sessionStorage', keys.pendingClaimAt) || 0);
    if (!pending) return false;
    if (pendingAt > 0 && now() - pendingAt <= config.pendingClaimMs) return true;
    clearPendingClaim();
    return false;
  }

  function isClosedRecently() {
    var closedAt = Number(storageGet('localStorage', keys.closedAt) || 0);
    return closedAt > 0 && now() - closedAt < config.closedCooldownMs;
  }

  function suppressForBuilder(cart) {
    if (isBuilderPage()) {
      storageSet('sessionStorage', keys.builderFunnel, '1');
      return true;
    }

    if (storageGet('sessionStorage', keys.builderFunnel) === '1') return true;

    if (cart && (cart.items || []).some(isBuilderCartLine)) {
      storageSet('sessionStorage', keys.builderFunnel, '1');
      return true;
    }

    return false;
  }

  function captureSuppression(reason, cart, subtotal, lastSubtotal) {
    if (subtotal < config.thresholdCents) return;
    captureOncePerSession('themeatery_a5_threshold_offer_suppressed', reason, eventProps(cart, {
      reason: reason,
      last_subtotal_cents: lastSubtotal
    }));
  }

  function shouldAttemptOpen(cart) {
    var subtotal = qualifyingSubtotalCents(cart);
    var lastSubtotal = Number(storageGet('sessionStorage', keys.lastSubtotal) || 0);
    storageSet('sessionStorage', keys.lastSubtotal, String(subtotal));

    if (suppressForBuilder(cart)) {
      captureSuppression('builder_or_membership', cart, subtotal, lastSubtotal);
      return false;
    }

    if (storageGet('sessionStorage', keys.opened) === '1') {
      captureSuppression('already_opened_session', cart, subtotal, lastSubtotal);
      return false;
    }

    if (storageGet('localStorage', keys.submitted) === '1') {
      captureSuppression('already_submitted', cart, subtotal, lastSubtotal);
      return false;
    }

    if (isClosedRecently()) {
      captureSuppression('closed_recently', cart, subtotal, lastSubtotal);
      return false;
    }

    return subtotal >= config.thresholdCents && lastSubtotal < config.thresholdCents;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to fetch cart');
      return response.json();
    });
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + url);
      return response.json().catch(function () { return {}; });
    });
  }

  function applyDiscount() {
    return postJson('/cart/update.js', {
      discount: config.discountCode,
      attributes: {
        a5_threshold_offer_claimed: 'true'
      }
    });
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    window.dispatchEvent(new CustomEvent('themeatery:a5-threshold-offer:cart-updated'));
  }

  function removeOfferGiftsFromCart(cart, reason) {
    var lines = offerGiftLines(cart);
    if (!lines.length) return Promise.resolve(null);

    return lines.reduce(function (promise, item) {
      return promise.then(function () {
        return postJson('/cart/change.js', {
          id: lineKey(item),
          quantity: 0
        });
      });
    }, Promise.resolve()).then(function () {
      clearPendingClaim();
      storageRemove('localStorage', keys.claimed);
      refreshCartUi();
      window.dispatchEvent(new CustomEvent('themeatery:a5-threshold-offer:gift-removed', {
        detail: { reason: reason || 'ineligible' }
      }));
      return reason || 'removed';
    });
  }

  function normalizeOfferGiftLine(cart) {
    var lines = offerGiftLines(cart);

    if (!lines.length) {
      return postJson('/cart/add.js', {
        items: [{ id: config.offerGiftVariantId, quantity: 1 }]
      });
    }

    return lines.reduce(function (promise, item, index) {
      return promise.then(function () {
        if (index > 0) {
          return postJson('/cart/change.js', { id: lineKey(item), quantity: 0 });
        }

        if (item.quantity !== 1) {
          return postJson('/cart/change.js', { id: lineKey(item), quantity: 1 });
        }

        return null;
      });
    }, Promise.resolve());
  }

  function verifyOfferIsFree(source) {
    return fetchCart().then(function (cart) {
      var lines = offerGiftLines(cart);
      if (lines.length === 1 && lines[0].quantity === 1 && isOfferGiftFree(lines[0])) {
        clearPendingClaim();
        storageSet('localStorage', keys.claimed, '1');
        refreshCartUi();
        return source;
      }

      return removeOfferGiftsFromCart(cart, 'discount-not-applied').then(function () {
        warn('[A5 threshold offer] removed gift because TRYWAGYU did not make it free');
        return null;
      });
    });
  }

  function ensureOfferInCart(source) {
    return fetchCart().then(function (cart) {
      if (suppressForBuilder(cart)) {
        return removeOfferGiftsFromCart(cart, 'builder-suppressed');
      }

      if (qualifyingSubtotalCents(cart) < config.thresholdCents) {
        return removeOfferGiftsFromCart(cart, 'below-threshold');
      }

      return normalizeOfferGiftLine(cart)
        .then(applyDiscount)
        .then(function () {
          return verifyOfferIsFree(source);
        });
    }).catch(function (error) {
      clearPendingClaim();
      return fetchCart().then(function (cart) {
        return removeOfferGiftsFromCart(cart, 'cart-update-failed');
      }).catch(function () {
        warn('[A5 threshold offer] cart update failed:', error.message);
        return null;
      });
    });
  }

  function reconcileExistingOffer(cart, reason) {
    var lines = offerGiftLines(cart);
    if (!lines.length) return Promise.resolve(null);

    if (suppressForBuilder(cart)) {
      return removeOfferGiftsFromCart(cart, 'builder-suppressed');
    }

    if (qualifyingSubtotalCents(cart) < config.thresholdCents) {
      return removeOfferGiftsFromCart(cart, 'below-threshold');
    }

    if (lines.length === 1 && lines[0].quantity === 1 && isOfferGiftFree(lines[0])) {
      return Promise.resolve(reason || 'already-free');
    }

    return applyDiscount().then(function () {
      return verifyOfferIsFree(reason || 'reconcile-existing-gift');
    });
  }

  function hasVisibleKlaviyoForm() {
    var bodyClass = document.body ? document.body.className || '' : '';
    return bodyClass.indexOf('klaviyo-prevent-body-scrolling') !== -1 ||
      Boolean(document.querySelector('.klaviyo-form'));
  }

  function scheduleOpenRenderCheck(cart, attempt, subtotal) {
    window.setTimeout(function () {
      if (storageGet('sessionStorage', keys.openedRendered) === '1' || hasVisibleKlaviyoForm()) {
        storageSet('sessionStorage', keys.openedRendered, '1');
        return;
      }

      if (storageGet('localStorage', keys.submitted) === '1') return;

      if (attempt < config.openMaxAttempts) {
        capture('themeatery_a5_threshold_offer_open_retry', eventProps(cart, {
          attempt: attempt + 1,
          previous_attempt: attempt,
          qualifying_subtotal_cents: subtotal
        }));
        openOffer(cart, 'retry');
        return;
      }

      captureOncePerSession('themeatery_a5_threshold_offer_open_failed_no_render', 'open_failed_no_render', eventProps(cart, {
        attempts: attempt,
        qualifying_subtotal_cents: subtotal
      }));
    }, config.openRetryDelayMs);
  }

  function openOffer(cart, source) {
    var subtotal = qualifyingSubtotalCents(cart);
    var attempt = Number(storageGet('sessionStorage', keys.openAttempts) || 0) + 1;

    storageSet('sessionStorage', keys.opened, '1');
    storageSet('sessionStorage', keys.openAttempts, String(attempt));
    if (attempt === 1) {
      storageRemove('sessionStorage', keys.openedRendered);
      storageRemove('sessionStorage', keys.openReported);
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', config.formId]);

    capture('themeatery_a5_threshold_offer_open_attempted', eventProps(cart, {
      attempt: attempt,
      source: source || 'threshold-crossed',
      qualifying_subtotal_cents: subtotal
    }));

    window.dispatchEvent(new CustomEvent('themeatery:a5-threshold-offer:open-attempted', {
      detail: { formId: config.formId, qualifyingSubtotal: subtotal, attempt: attempt }
    }));

    scheduleOpenRenderCheck(cart, attempt, subtotal);
  }

  function checkCart(reason) {
    if (checking) return;
    checking = true;

    fetchCart().then(function (cart) {
      var hasOfferGift = offerGiftLines(cart).length > 0;

      if (hasOfferGift) {
        reconcileExistingOffer(cart, reason);
      } else if (isPendingClaimActive()) {
        ensureOfferInCart('pending-claim');
      }

      if (shouldAttemptOpen(cart)) {
        openOffer(cart);
      }
    }).catch(function (error) {
      warn('[A5 threshold offer] check skipped:', reason, error.message);
    }).finally(function () {
      checking = false;
    });
  }

  function scheduleCheck(reason, delay) {
    if (suppressForBuilder()) return;
    window.clearTimeout(scheduledCheck);
    scheduledCheck = window.setTimeout(function () {
      checkCart(reason || 'scheduled');
    }, delay == null ? 350 : delay);
  }

  function isCartMutation(url) {
    var path = pathFromUrl(url);
    return /\/cart\/(add|change|update|clear)\.js$/i.test(path) || /\/cart\/add$/i.test(path);
  }

  function wrapFetch() {
    if (fetchWrapped || typeof window.fetch !== 'function') return;
    fetchWrapped = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = parseRequestUrl(arguments[0]);
      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartMutation(url)) scheduleCheck('fetch:' + pathFromUrl(url), 650);
        return response;
      });
    };
  }

  function wrapXhr() {
    if (xhrWrapped || !window.XMLHttpRequest) return;
    xhrWrapped = true;
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__themeateryA5CartUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__themeateryA5CartUrl) {
        this.addEventListener('loadend', function () {
          if (isCartMutation(this.__themeateryA5CartUrl)) {
            scheduleCheck('xhr:' + pathFromUrl(this.__themeateryA5CartUrl), 650);
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  function bindFormEvents() {
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event.detail || {};
      var formId = detail.formId || detail.formID;
      if (formId && formId !== config.formId) return;

      if (detail.type === 'open' || detail.type === 'viewedStep') {
        storageSet('sessionStorage', keys.openedRendered, '1');
        if (storageGet('sessionStorage', keys.openReported) !== '1') {
          storageSet('sessionStorage', keys.openReported, '1');
          capture('themeatery_a5_threshold_offer_opened', {
            form_id: config.formId,
            form_version_id: detail.formVersionId || null,
            event_type: detail.type,
            path: window.location.pathname
          });
        }
      }

      if (detail.type === 'close' && storageGet('sessionStorage', keys.pendingClaim) !== '1') {
        storageSet('localStorage', keys.closedAt, String(now()));
        capture('themeatery_a5_threshold_offer_closed', {
          form_id: config.formId,
          path: window.location.pathname
        });
      }

      if (detail.type === 'submit') {
        storageSet('localStorage', keys.submitted, '1');
        storageSet('localStorage', keys.closedAt, '0');
        markPendingClaim();
        capture('themeatery_a5_threshold_offer_submitted', {
          form_id: config.formId,
          path: window.location.pathname
        });
        ensureOfferInCart('klaviyo-submit');
      }

      if (detail.type === 'redirectedToUrl') {
        markPendingClaim();
        window.setTimeout(function () {
          ensureOfferInCart('klaviyo-redirect');
        }, 1200);
      }
    });
  }

  function bindFallbackEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      if (isCartMutation(form.getAttribute('action') || '')) scheduleCheck('cart-form-submit', 1000);
    }, true);

    ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad', 'theme:cart:change'].forEach(function (name) {
      document.addEventListener(name, function () { scheduleCheck(name, 500); });
    });
  }

  function init() {
    if (isBuilderPage()) {
      storageSet('sessionStorage', keys.builderFunnel, '1');
      return;
    }

    wrapFetch();
    wrapXhr();
    bindFormEvents();
    bindFallbackEvents();
    scheduleCheck('initial', 1200);
  }

  window.themeateryA5ThresholdOffer = {
    config: config,
    check: checkCart,
    ensureOfferInCart: ensureOfferInCart,
    qualifyingSubtotalCents: qualifyingSubtotalCents,
    isBuilderPage: isBuilderPage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
